<ion-header
  data-cy="import-non-usf-product-modal-header"
  class="ion-no-border"
  [ngClass]="
    platform === platformRef.desktop
      ? 'ion-header-modal-desktop'
      : platform === platformRef.tablet
        ? 'ion-header-modal-tablet'
        : 'ion-header-modal-mobile'
  "
>
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button
        *ngIf="platform === platformRef.desktop"
        id="close-modal-btn"
        datea-cy="close-import-non-usf-product-modal-icon"
        (click)="dismissModal()"
      >
        <ion-icon slot="icon-only" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-label [attr.data-cy]="'copy-to-list-title'" class="title-bold">
      {{
        'i18n.inventory.importNonUsfProdcutsModal.importProducts' | translate
      }}
    </ion-label>
  </ion-toolbar>
</ion-header>
<ion-content
  scrollY="false"
  [ngClass]="
    platform === platformRef.desktop
      ? 'ion-content-modal-desktop'
      : platform === platformRef.tablet
        ? 'ion-content-modal-tablet'
        : 'ion-content-modal-mobile'
  "
>
  <div class="subtitle-text">
    {{
      (platform === platformRef.desktop
        ? 'i18n.inventory.importNonUsfProdcutsModal.fileInstructions'
        : 'i18n.inventory.importNonUsfProdcutsModal.mobileInstructions'
      ) | translate
    }}
  </div>
  <app-file-picker
    [error]="displayPageError"
    [showDefaultErrorMessage]="false"
    [platform]="platform"
    data-cy="import-non-usf-product-file-picker"
    [file]="file"
    (fileAddEvent)="handleFileAddRequest()"
    (fileDeleteEvent)="handleFileDeleteRequest()"
    (processFileEvent)="processFile($event)"
  ></app-file-picker>

  <p class="bad-data" *ngIf="displayPageError | async">
    {{ 'i18n.inventory.importNonUsfProdcutsModal.fileError' | translate }}
  </p>

  <p class="template-link" (click)="handleDownloadNonUsfTemplate()">
    <ion-icon
      name="download-outline"
      data-cy="import-template-download-icon"
    ></ion-icon>
    {{
      'i18n.inventory.importNonUsfProdcutsModal.downloadImportTemplate'
        | translate
    }}
  </p>
  <p
    *ngIf="showDownloadGlCode"
    class="template-link"
    (click)="handleDownloadGlCode()"
  >
    <ion-icon
      name="download-outline"
      data-cy="gl-code-template-download-icon"
    ></ion-icon>
    {{ 'i18n.inventory.importNonUsfProdcutsModal.downloadGlCodes' | translate }}
  </p>
</ion-content>
<ion-footer class="ion-footer-modal">
  <ion-toolbar>
    <ion-buttons>
      <ion-button
        data-cy="cancel-import-non-usf-product"
        [ngClass]="
          platform === platformRef.mobile
            ? 'usf-outline-green-mobile-modal-button'
            : 'usf-outline-green-dsktp-tblt-modal-button'
        "
        (click)="dismissModal()"
      >
        {{ 'i18n.common.cancel' | translate }}
      </ion-button>

      <ion-button
        data-cy="submit-import-non-usf-product"
        [disabled]="!isFileValid"
        [ngClass]="
          isFileValid
            ? platform === platformRef.mobile
              ? 'usf-fill-green-mobile-modal-button'
              : 'usf-fill-green-dsktp-tblt-modal-button'
            : platform === platformRef.mobile
              ? 'usf-fill-disabled-mobile-modal-button'
              : 'usf-fill-disabled-dsktp-tblt-modal-button'
        "
        (click)="submit()"
      >
        {{ 'i18n.common.submit' | translate }}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
